import axios from 'axios'
import { voiceUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
import store from '@/store/index'

// 上传语音文件
export function uploadFile(params) {
  const url = voiceUrl + '/voice/client/upload'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '上传语音文件', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询用户会话列表
export function getSelectList(params) {
  const url = voiceUrl + '/session/select/list'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '查询用户会话列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询语音列表
export function getVoiceList(params) {
  const url = voiceUrl + '/voice/list'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '查询语音列表', res)
    }
    // 内外网ip转换
    if (!store.getters.isCloud && res.data && res.data.data && res.data.data.list) {
      let innerIp = store.getters.innerIp
      let outerIp = store.getters.outerIp
      let thisIp = location.hostname
      let replaceFrom = ''
      let replaceTo = ''
      if (thisIp.indexOf(innerIp) > -1) {
        replaceFrom = outerIp
        replaceTo = innerIp
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        replaceFrom = innerIp
        replaceTo = outerIp
      }
      if (replaceFrom && replaceTo) {
        res.data.data.list.forEach(item => {
          if (item.address) {
            if (item.address.indexOf(replaceTo) > -1) {
              return Promise.resolve(res.data)
            }
            item.address = item.address.replace(replaceFrom, replaceTo)
          }
        })
      }
    }
    return Promise.resolve(res.data)
  })
}

// 查询机构树结构用户
export function getSelecttreeList(params) {
  const url = voiceUrl + '/session/select/user/tree'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '查询机构树结构用户', res)
    }
    return Promise.resolve(res.data)
  })
}

// 用户新增通信会话
export function saveCall(params) {
  const url = voiceUrl + '/session/save/call'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '用户新增通信会话', res)
    }
    return Promise.resolve(res.data)
  })
}

// 用户新增广播会话
export function saveBroadcast(params) {
  const url = voiceUrl + '/session/save/broadcast'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '添加广播群组', res)
    }
    return Promise.resolve(res.data)
  })
}

// 用户修改广播成员
export function updateBroadcast(params) {
  const url = voiceUrl + '/session/update/broadcast'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '用户修改广播成员', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除聊天用户/群组
export function delSession(params) {
  const url = voiceUrl + '/session/delete/' + params.id
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '删除聊天用户/群组', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询广播群组机构树结构用户
export function getUserTree(params) {
  const url = voiceUrl + '/session/select/session/user'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '查询广播群组机构树结构用户', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询会话成员列表信息
export function getMember(params) {
  const url = voiceUrl + '/session/select/session/member'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '查询会话成员列表信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 刷新语音播放路径
export function refreshVoice(params) {
  const url = voiceUrl + '/voice/refresh'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '刷新语音播放路径', res)
    }
    return Promise.resolve(res.data)
  })
}

// 已读未读
export function updateSessionRead(params) {
  const url = voiceUrl + '/session/update/session/read'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '修改语音消息已读', res)
    }
    return Promise.resolve(res.data)
  })
}
